import { resolveFileUrl } from "../urlHelpers.js"
import { jsenvBundlingDirectoryUrl } from "../jsenvBundlingDirectoryUrl.js"
import { generateBundle } from "../generateBundle/generateBundle.js"

export const generateSystemJsBundle = async ({
  bundleDirectoryRelativePath = "./dist/systemjs",
  ...rest
}) =>
  generateBundle({
    format: "systemjs",
    balancerTemplateFileUrl: resolveFileUrl(
      "./src/generateSystemJsBundle/systemjs-balancer-template.js",
      jsenvBundlingDirectoryUrl,
    ),
    balancerDataAbstractSpecifier: "/.jsenv/systemjs-balancer-data.js",
    bundleDirectoryRelativePath,
    ...rest,
  })
